import { Component, OnDestroy, OnInit, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { webPermisosSignal } from "app/services/auth/web-permisos.signal";
import { DialogClimaComponent } from "./dialog-clima/dialog-clima.component";

import { ImagesService } from "app/services/helper/images.service";
import { RankingsService } from "app/services/rankings/rankings.service";
import { BadgesService } from "../../services/badges/badges.service";
import { PostsService } from "../../services/posts/posts.service";
import { ProjectService } from "../../services/project/project.service";
import { UserService } from "../../services/user/user.service";

import { Project } from "app/shared/models/project.interface";
import { Badge } from "../../shared/models/badge.interface";
import { Post } from "../../shared/models/posts.interface";
import { ProfileUser, User } from "../../shared/models/user.interface";

import { ActivatedRoute, Router } from "@angular/router";
import { feedAnimations } from "app/animations";
import { AuthService } from "app/services/auth/auth.service";
import { EvaluationService } from "app/services/evaluation/evaluation.service";
import { PersonService } from "app/services/person/person.service";
import moment from "app/util/dayjs";
import { driver } from "driver.js";
import { Subscription } from "rxjs";
import { DialogDarBadgeComponent } from "../../../app/components/dialog-dar-badge/dialog-dar-badge.component";

@Component({
    selector: "app-inicio",
    templateUrl: "./inicio.component.html",
    styleUrls: ["./inicio.component.scss"],
    animations: feedAnimations,
    standalone: false
})
export class InicioComponent implements OnInit, OnDestroy {
    users: Array<any> = [];
    readonly usersRecibidas = signal<Array<any>>([]);
    readonly usersEntregadas = signal<Array<any>>([]);
    fechaActual = new Date();

    readonly user = signal<User | null>(null);
    readonly profileUser = signal<ProfileUser>(null!);
    pageTimeline: number;
    readonly badgesTimeline = signal<Array<Badge>>([]);
    hasMoreTimeline: boolean;
    pageRecentNews: number;
    readonly recentNews = signal<Array<Post>>([]);
    hasMoreRecentNews: boolean;
    pageRecentNewsFun: number;
    readonly recentNewsFun = signal<Array<Post>>([]);
    hasMoreRecentNewsFun: boolean;
    readonly project = signal<Project | null>(null);
    readonly topByCompetency = signal<any>(null);
    readonly selectedCompetencia = signal<any>(null);
    maxPointCompetenciAux = 0;
    monthIndex: number = new Date().getMonth() + 1;
    yearIndex: number = new Date().getFullYear();

    private updateBadgeSubscription: Subscription;

    readonly recentNewsLoaded = signal(false);
    readonly recentNewsLoadedFun = signal(false);
    readonly badgesTimelineLoaded = signal(false);
    readonly competenciesLoaded = signal(false);
    idsBadges: Array<Number>;

    readonly projectId = signal<number | undefined>(undefined);

    readonly evaluation = signal<any>(null);
    readonly evaluationPeriod = signal<any>(null);
    readonly canDo = signal(false);

    badgesTandem = 0;
    private tandemEvaluationInitialized = false;
    constructor(
        public dialog: MatDialog,
        private userSvc: UserService,
        private badgesSvc: BadgesService,
        private postsSvc: PostsService,
        private route: ActivatedRoute,
        private projectSvc: ProjectService,
        private rankSvc: RankingsService,
        private imagesSvc: ImagesService,
        private personSvc: PersonService,
        private router: Router,
        private evaluationSvc: EvaluationService,
        private authSvc: AuthService
    ) {
        this.profileUser.set({
            totalNumBadgeReceived: 0,
            totalNumBadgeSended: 0,
            totalMonedas: 0,
            totalRankingBronze: 0,
            totalRankingSilver: 0,
            totalRankingGold: 0,
            climaToday: 0,
            totalPublicaciones: 0,
            delegacion: "",
            persona: null
        });
        this.idsBadges = [];
        this.pageTimeline = 0;
        this.badgesTimeline.set([]);
        this.pageRecentNews = 0;
        this.recentNews.set([]);

        this.pageRecentNewsFun = 0;
        this.recentNewsFun.set([]);
        this.updateBadgeSubscription = badgesSvc.getUpdate().subscribe((message) => {
            this.loadTimeline(true);
            this.userSvc.profile().subscribe((data: any) => {
                this.profileUser.set(data);
            });
        });
    }
    readonly permisosMedallas = webPermisosSignal(this.authSvc, "WEB-MEDALLAS");
    readonly permisosPublicaciones = webPermisosSignal(this.authSvc, "WEB-PUBLICACIONES");
    readonly permisosMedallasCL = webPermisosSignal(this.authSvc, "WEB-MEDALLAS-COMENTARIOSLIKES");
    readonly permisosPublicacionesCL = webPermisosSignal(this.authSvc, "WEB-PUBLICACIONES-COMENTARIOSLIKES");
    readonly permisosClima = webPermisosSignal(this.authSvc, "WEB-CLIMA");
    readonly permisosSIED = webPermisosSignal(this.authSvc, "WEB-EVALUACIONES");
    readonly permisosPoll = webPermisosSignal(this.authSvc, "WEB-ENCUESTAS");
    readonly permisosTienda = webPermisosSignal(this.authSvc, "WEB-TIENDA");
    readonly permisosObjetivos = webPermisosSignal(this.authSvc, "WEB-OBJETIVOS");
    ngOnInit(): void {
        this.userSvc.getUser().subscribe((data: User) => {
            if (data["onBoardingOK"] == 0 && this.projectId() == 472) {
                this.router.navigate(["onboarding"]);
            }
            this.user.set(data);
            this.maybeInitTandemEvaluation();
        });

        this.userSvc.profile().subscribe((data: any) => {
            this.profileUser.set(data);

            if (data.delegacion) {
                this.badgesSvc.getMedallasDelegacion(data.delegacion.id).subscribe((data) => {
                    this.users = data;
                    this.usersRecibidas.set(Array.from(this.users).sort((a, b) => b.recibidas - a.recibidas));
                    this.usersEntregadas.set(Array.from(this.users).sort((a, b) => b.entregadas - a.entregadas));
                });
            }
        });

        this.projectSvc.getProjectConfig().subscribe(
            (data) => {
                this.project.set(data);
                this.projectId.set(data.id);
                this.maybeInitTandemEvaluation();
                if (data.id == 472) {
                    this.pageRecentNews = 0;
                    this.recentNews.set([]);
                    this.loadRecentNews();
                    this.loadRecentNewsFun();
                }
            },
            (err) => {}
        );

        this.badgesSvc.checkSemanales().subscribe((data) => {
            console.log("Semanales", data);
            if (data) {
                this.badgesTandem = data.length;
            }
        });
        this.loadTimeline(true);
        this.loadRecentNews();
        this.loadTopByCompetency();
        let darBadge = false;
        let badgeReturn = 0;
        this.route.queryParams.subscribe((params) => {
            darBadge = params["darBadge"];
            badgeReturn = params["badgeReturn"];
        });

        if (darBadge !== undefined && darBadge !== null) {
            this.openDialogBadge(badgeReturn);
        }
        let idarray = [];
        this.userSvc.getUser().subscribe((data) => {
            this.personSvc.getPerson(data.id).subscribe(async (data) => {
                localStorage.setItem("roles", JSON.stringify(data.roles));
            });
            this.personSvc.getListaTrabajadores(data.id).subscribe((data) => {
                for (let trab of data) {
                    idarray.push(trab.id);
                }
                localStorage.setItem("bossOf", JSON.stringify(idarray));
            });
        });
    }

    loadTimeline(reload: boolean): void {
        if (reload) {
            this.badgesTimelineLoaded.set(false);
        }
        this.badgesSvc.timeline(this.pageTimeline).subscribe({
            next: (data: any) => this.processDataTimeline(data, reload),
            error: () => this.badgesTimelineLoaded.set(true)
        });
    }

    private maybeInitTandemEvaluation(): void {
        if (this.tandemEvaluationInitialized) {
            return;
        }
        const currentUser = this.user();
        const proj = this.project();
        if (!currentUser || !proj?.tandemMode) {
            return;
        }
        this.tandemEvaluationInitialized = true;
        this.evaluationSvc.getRegistroTandem(currentUser.id).subscribe((data) => {
            if (data.canDo) {
                this.canDo.set(data.canDo);
                const currentTime = moment();
                const is13ormore = currentTime.hour() >= 13;
                if (is13ormore) this.remindDailyEvaluation();
            }
        });
        this.evaluationSvc.getEvaluationPeriods("EVALUATION_VH").subscribe((data: any) => {
            this.evaluationPeriod.set(data[0]);
            const period = this.evaluationPeriod();
            if (period && currentUser.puestos?.[0]) {
                this.evaluationSvc
                    .getEvaluationVHByUser(period.id, currentUser.id, currentUser.puestos[0].id)
                    .subscribe((data: any) => {
                        this.evaluation.set(data);
                        console.log("getEvaluationVHByUser", this.evaluation());
                    });
            }
        });
    }

    loadRecentNews(): void {
        // Solo ocultar la lista en la carga inicial; al paginar se mantiene el scroll.
        if (this.recentNews().length === 0) {
            this.recentNewsLoaded.set(false);
        }
        const request =
            this.project()?.id == 472
                ? this.postsSvc.recentNews(this.pageRecentNews, { funespana_especial: 0 })
                : this.postsSvc.recentNews(this.pageRecentNews);
        request.subscribe({
            next: (data: any) => this.processDataRecentNews(data),
            error: () => this.recentNewsLoaded.set(true)
        });
    }

    loadRecentNewsFun(): void {
        if (this.recentNewsFun().length === 0) {
            this.recentNewsLoadedFun.set(false);
        }
        this.postsSvc.recentNews(this.pageRecentNewsFun, { funespana_especial: 1 }).subscribe({
            next: (data: any) => this.processDataRecentNewsFun(data),
            error: () => this.recentNewsLoadedFun.set(true)
        });
    }

    private processDataTimeline(data: any, reload: boolean) {
        let timeline = reload ? [] : [...this.badgesTimeline()];
        if (reload) {
            this.idsBadges = [];
        }
        this.hasMoreTimeline = data.hasMore;

        for (let itemBadge of data.elements) {
            if (this.idsBadges.includes(itemBadge.id)) {
                for (let badge of timeline) {
                    if (badge.id == itemBadge.id) {
                        if (badge["competencyIndicator"]) {
                            badge["competencyIndicator"] = badge["competencyIndicator"].concat(
                                itemBadge.competencyIndicator
                            );
                        }
                    }
                }
            } else {
                timeline.push(<Badge>itemBadge);
                this.idsBadges.push(itemBadge.id);
            }
        }
        this.badgesTimeline.set(timeline);
        this.badgesTimelineLoaded.set(true);
    }

    private processDataRecentNews(data: any) {
        this.hasMoreRecentNews = data.hasMore;
        const next = [...this.recentNews()];
        for (let post of data.elements) {
            if (
                !post["title_prefix"].includes("${ranking.month}") ||
                (this.project()?.enabled_rankings && this.project()?.entryPoint?.["showRankingPost"])
            ) {
                next.push(<Post>post);
            }
        }
        this.recentNews.set(next);
        this.recentNewsLoaded.set(true);
    }

    onSrollTimeline() {
        if (this.hasMoreTimeline) {
            this.pageTimeline++;
            this.loadTimeline(false);
        }
    }
    onSrollRecentNews() {
        if (this.hasMoreRecentNews) {
            this.pageRecentNews++;
            this.loadRecentNews();
        }
    }

    private processDataRecentNewsFun(data: any) {
        this.hasMoreRecentNewsFun = data.hasMore;
        const next = [...this.recentNewsFun()];
        for (let post of data.elements) {
            if (
                !post["title_prefix"].includes("${ranking.month}") ||
                (this.project()?.enabled_rankings && this.project()?.entryPoint?.["showRankingPost"])
            ) {
                next.push(<Post>post);
            }
        }
        this.recentNewsFun.set(next);
        this.recentNewsLoadedFun.set(true);
    }
    onSrollRecentNewsFun() {
        if (this.hasMoreRecentNewsFun) {
            this.pageRecentNewsFun++;
            this.loadRecentNewsFun();
        }
    }

    openDialogClima(valueClima): void {
        if (this.profileUser().climaToday === 0) {
            if (this.projectId() == 10) {
                this.userSvc.saveClima(valueClima, "").subscribe((data) => {
                    if (data && data !== undefined) {
                        this.profileUser.update((p) => ({ ...p, climaToday: Number(valueClima) }));
                    }
                });
            } else {
                const dialogRef = this.dialog.open(DialogClimaComponent, {
                    data: {
                        value: valueClima,
                        mandatoryReason: this.project()?.mandatoryReasonClima ? true : false
                    },
                    panelClass: "panel-feedbalia"
                });
                dialogRef.updatePosition({ top: "2rem" });

                dialogRef.afterClosed().subscribe((result) => {
                    if (result && result !== undefined) {
                        this.profileUser.update((p) => ({ ...p, climaToday: result }));
                    }
                });
            }
        }
    }

    loadTopByCompetency(year = "", month = "", type = "grantee") {
        switch (type) {
            case "grantor":
                this.rankSvc.topCompetencyGrantor(year, month).subscribe((data: any) => {
                    this.topByCompetency.set(data);

                    if (data[0]) {
                        this.selectedCompetencia.set(data[0]);
                    }

                    if (data[0] && data[0].topFive[0]) {
                        this.maxPointCompetenciAux = data[0].topFive[0].count;
                    } else {
                        this.maxPointCompetenciAux = 0;
                    }

                    this.competenciesLoaded.set(true);
                });
                break;
            default:
                this.rankSvc
                    .topCompetencyGrantee(this.yearIndex.toString(), this.monthIndex.toString())
                    .subscribe((data: any) => {
                        this.topByCompetency.set(data);

                        if (data[0]) {
                            this.selectedCompetencia.set(data[0]);
                        }

                        if (data[0] && data[0].topFive[0]) {
                            this.maxPointCompetenciAux = data[0].topFive[0].count;
                        } else {
                            this.maxPointCompetenciAux = 0;
                        }

                        this.competenciesLoaded.set(true);
                    });
                break;
        }
    }

    private openDialogBadge(badgeReturn) {
        const dialogRef = this.dialog.open(DialogDarBadgeComponent, {
            panelClass: ["panel-feedbalia", "dar-badge"],
            width: window.screen.width > 768 ? "50vw" : "100vw",
            disableClose: true,
            autoFocus: false,
            data: { badgeReturn: badgeReturn }
        });
        dialogRef.updatePosition({ top: "2rem" });
    }

    nextSection() {
        const top = this.topByCompetency();
        const selected = this.selectedCompetencia();
        if (!top?.length || !selected) {
            return;
        }
        var ind = top.indexOf(selected);
        if (ind != top.length - 1) {
            this.selectedCompetencia.set(top[top.indexOf(selected) + 1]);
        } else {
            this.selectedCompetencia.set(top[0]);
        }
    }

    previousSection() {
        const top = this.topByCompetency();
        const selected = this.selectedCompetencia();
        if (!top?.length || !selected) {
            return;
        }
        var ind = top.indexOf(selected);
        if (ind != 0) {
            this.selectedCompetencia.set(top[top.indexOf(selected) - 1]);
        } else {
            this.selectedCompetencia.set(top[top.length - 1]);
        }
    }

    rankBg(index) {
        switch (Number(index)) {
            case 1:
                return "gold-bg";
            case 2:
                return "silver-bg";
            case 3:
                return "bronze-bg";
            default:
                return "none-bg";
        }
    }

    getImagePerson(username: string) {
        return this.imagesSvc.getImagePerson(username, this.projectId());
    }

    getImagePersonThumb(username: string) {
        return this.imagesSvc.getImageThumb(username);
    }

    calcHeightTop(total: number) {
        let allValues = 0;
        for (let elem of this.selectedCompetencia()?.topFive ?? []) {
            allValues += Number(elem.count);
        }
        var height: number = 100;
        height = (total * 100) / allValues;
        height = height + 20;
        if (height > 100) {
            height = 100;
        }

        return height + "%";
    }

    convertirMes(numeroMes) {
        var meses = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ];

        if (numeroMes >= 1 && numeroMes <= 12) {
            return meses[numeroMes - 1];
        }
    }

    ngOnDestroy(): void {
        this.updateBadgeSubscription.unsubscribe();
    }

    goToSied() {
        this.router.navigate(["/sied"]);
    }

    goToPoll() {
        this.router.navigate(["/poll"]);
    }

    remindDailyEvaluation() {
        setTimeout(() => {
            const driverObj = driver({
                animate: true,
                showButtons: [null],
                steps: [
                    {
                        element: "#registro-diario",
                        popover: {
                            title: "Recordatorio de registro diario",
                            description: "¡Recuerda que debes realizar tu registro diario!"
                        }
                    }
                ]
            });

            driverObj.drive();
            window.addEventListener("click", () => {
                driverObj.destroy();
            });
        }, 4000);
    }

    goToRegistroDiario() {
        this.router.navigate(["/vuelta-d"]);
    }

    goToObjetivos() {
        this.router.navigate(["/objetivos"]);
    }

    formatDate(date: string) {
        if (!date) {
            return "";
        }
        let _date = moment(date).format("DD/MM/YYYY HH:mm");
        return _date;
    }

    loadAutoEvaluation(evaluation, isNew?: boolean) {
        const _params = {
            formId: evaluation.formId,
            personId: this.user()!.id,
            periodId: this.evaluationPeriod()!.id,
            iterationNumber: isNew ? Number(evaluation.iterationNumber) + 1 : evaluation.iterationNumber
        };
        this.router.navigate(["/vuelta-d/form"], { queryParams: _params });
    }
    checkAlumn() {
        const currentUser = this.user();
        if (currentUser) {
            if (currentUser.puestos) {
                if (currentUser.puestos.length > 0) {
                    if (currentUser.puestos[0].puesto.includes("ALUMN")) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}
